﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalCMS`,
  scopes: ExtHubRequest,
});
const apiAppPack = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalAppPackage`,
  scopes: ExtHubRequest,
});
const api3 = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalPromoItem`,
  scopes: ExtHubRequest,
});

apiAppPack.createEntities([{ name: 'GetAppPackageProductByProductID' }]);

api3.createEntities([
  { name: 'GetPromoItemList' },
  { name: 'GetPromoItemById' },
  { name: 'GetColors' },
  { name: 'GetSizes' },
]);

api.createEntities([
  //All purpose
  { name: 'GetDivisionList' },
  { name: 'GetProductsListForRef' },
  //Emergency Notes
  { name: 'GetEmergencyNoteList' },
  { name: 'GetEmergencyNotes' },
  { name: 'GetEmergencyNotesByDivision' },
  { name: 'DeleteEmergencyNote' },
  { name: 'AddOrUpdateEmergencyNote' },
  //Products
  { name: 'GetProductsList' },
  { name: 'GetProductById' },
  { name: 'GetProductLines' },
  { name: 'GetUnderWritingTypes' },
  { name: 'AddOrUpdateProduct' },
  { name: 'DeleteProduct' },
  { name: 'UploadProductFile' },
  //Promos
  { name: 'GetPromosList' },
  { name: 'GetPromoById' },
  { name: 'GetTemplateTypes' },
  { name: 'AddOrUpdatePromo' },
  { name: 'DeletePromo' },
  { name: 'UploadPromosFile' },
  //PromoItem
  { name: 'AddNewColor' },

  { name: 'GetPromoItemTemplateTypes' },
  { name: 'GetPromoItemCategories' },
  { name: 'GetPromoItemCompanies' },
  { name: 'AddOrUpdatePromoItem' },

  { name: 'DeletePromoItem' },
  { name: 'UploadPromoItemFile' },
  { name: 'GetPromoItemLinksById' },
  { name: 'AddOrUpdatePromoItemLink' },
  { name: 'DeletePromoItemLink' },
  //OnBoarding
  { name: 'GetOnBoardingList' },
  { name: 'GetOnBoardingById' },
  { name: 'GetOnBoardingCategories' },
  { name: 'AddOrUpdateOnBoarding' },
  { name: 'DeleteOnBoarding' },
  { name: 'AddOnBoardingCategory' },
  { name: 'UploadOnBoardingFile' },
  //Software
  { name: 'GetSoftwareList' },
  { name: 'GetSoftwareById' },
  { name: 'GetSoftwareCategories' },
  { name: 'AddOrUpdateSoftware' },
  { name: 'DeleteSoftware' },
  { name: 'UploadSoftwareFile' },
  { name: 'UploadSoftwareImageFile' },
  //Compliance Portal
  { name: 'GetCompliancePortalList' },
  { name: 'GetCompliancePortalById' },
  { name: 'GetCompliancePortalCategories' },
  { name: 'AddOrUpdateCompliancePortal' },
  { name: 'DeleteCompliancePortal' },
  { name: 'UploadCompliancePortalFile' },
  { name: 'AddCompliancePortalCategory' },
  { name: 'DeleteCompliancePortalCategory' },
  //News
  { name: 'GetNewsList' },
  { name: 'GetNewsById' },
  { name: 'GetNewsCategories' },
  { name: 'GetProductCategories' },
  { name: 'AddOrUpdateNews' },
  { name: 'DeleteNews' },
  { name: 'UploadNewsFile' },
  //Brokerage
  { name: 'GetBrokerageList' },
  { name: 'GetBrokerageById' },
  { name: 'GetBrokerageCategories' },
  { name: 'GetBrokerageCompanies' },
  { name: 'AddOrUpdateBrokerage' },
  { name: 'DeleteBrokerage' },
  { name: 'UploadBrokerageFile' },
  { name: 'AddBrokerageCompany' },
  { name: 'AddBrokerageCategory' },
  { name: 'GetBrokerageLinksById' },
  { name: 'AddOrUpdateBrokerageLink' },
  { name: 'DeleteBrokerageItemLink' },
  //Learning Center
  { name: 'GetLearningCenterList' },
  { name: 'GetLearningCenterById' },
  { name: 'GetLearningCenterCategories' },
  { name: 'AddOrUpdateLearningCenter' },
  { name: 'DeleteLearningCenterItem' },
  { name: 'AddLearningCenterCategory' },
  { name: 'UploadLearningCenterFile' },
  { name: 'DeleteLearningCenterCategory' },
  //Product Toolkit
  { name: 'GetProductToolkitList' },
  { name: 'GetProductToolkitById' },
  { name: 'GetProductToolkitCategoriesList' },
  { name: 'GetRecruitingAndSelectionList' },
  { name: 'AddOrUpdateProductToolkit' },
  { name: 'DeleteProductToolkitItem' },
  { name: 'GetRecruitingSupportList' },
  { name: 'UploadProductToolkitFile' },
  //Recruiting
  { name: 'GetRecruitingList' },
  { name: 'GetRecruitingById' },
  { name: 'GetRecruitingCategories' },
  { name: 'AddOrUpdateRecruiting' },
  { name: 'DeleteRecruiting' },
  { name: 'AddRecruitingCategory' },
  { name: 'UploadRecruitingFile' },
  //Brokerage Headers
  { name: 'GetBrokerageHeaderList' },
  { name: 'GetBrokerageHeaderById' },
  { name: 'AddOrUpdateBrokerageHeader' },
  { name: 'DeleteBrokerageHeader' },
  //Marketing
  { name: 'GetMarketItemByID' },
  { name: 'SaveMarketingItem' },
  { name: 'GetMarketingCmsList' },
  { name: 'DeleteMarketingItem' },
  { name: 'AddMarketingCampaign' },
  { name: 'DeleteMarketingCampaign' },
  //Selling Techniques
  { name: 'AddOrUpdateSellingTechnique' },
  { name: 'GetSellingTechniqueCategoryList' },
  { name: 'GetSellingTechniqueByID' },
  { name: 'DeleteTechniqueByID' },
  { name: 'UploadSellingTechniquesFile' },
  { name: 'GetSellingTechniqueListCMS' },
  //ISD Marketing
  { name: 'AddOrUpdateISDMarketing' },
  { name: 'DeleteISDMarketing' },
  { name: 'GetISDMarketingByID' },
  { name: 'AddISDMarketingCategory' },
  { name: 'UploadISDMarketingFile' },
  //App Package Links
  { name: 'AddOrUpdateAppPackageLinkID' },
  { name: 'DeleteAppPackageLinkID' },
  // Forms
  { name: 'AddOrUpdateForm' },
  { name: 'GetFormsList' },
  { name: 'GetFormsPaginatedList' },
  { name: 'GetFormById' },
  { name: 'GetFormCategories' },
  { name: 'GetFormProducts' },
  { name: 'GetStates' },
  { name: 'DeleteFormByID' },
  { name: 'DeleteFormFile' },
  { name: 'UploadFormFile' },
  { name: 'GetLinkTypes' },
]);

//all purpose
const GetDivisionList = () => api.endpoints.GetDivisionList.post();
const GetProductsListForRef = () => api.endpoints.GetProductsListForRef.post();

//emergency notes
const GetEmergencyNoteList = () => api.endpoints.GetEmergencyNoteList.post();
const GetEmergencyNotes = () => api.endpoints.GetEmergencyNotes.post();
const GetEmergencyNotesByDivision = (body) => api.endpoints.GetEmergencyNotesByDivision.post(body);
const DeleteEmergencyNote = (body) => api.endpoints.DeleteEmergencyNote.post(body);
const AddOrUpdateEmergencyNote = (body) => api.endpoints.AddOrUpdateEmergencyNote.post(body);

//products
const GetProductsList = () => api.endpoints.GetProductsList.post();
const GetProductById = (body) => api.endpoints.GetProductById.post(body);
const GetProductLines = () => api.endpoints.GetProductLines.post();
const GetUnderWritingTypes = () => api.endpoints.GetUnderWritingTypes.post();
const DeleteProduct = (body) => api.endpoints.DeleteProduct.post(body);
const AddOrUpdateProduct = (body) => api.endpoints.AddOrUpdateProduct.post(body);
const UploadProductFile = (data) => api.endpoints.UploadProductFile.postData(data);

//promos
const GetPromosList = () => api.endpoints.GetPromosList.post();
const GetPromoById = (body) => api.endpoints.GetPromoById.post(body);
const GetTemplateTypes = () => api.endpoints.GetTemplateTypes.post();
const DeletePromo = (body) => api.endpoints.DeletePromo.post(body);
const AddOrUpdatePromo = (body) => api.endpoints.AddOrUpdatePromo.post(body);
const UploadPromosFile = (data) => api.endpoints.UploadPromosFile.postData(data);

//promo item
const AddNewColor = (body) => api.endpoints.AddNewColor.post(body);
const GetPromoItemList = () => api3.endpoints.GetPromoItemList.post();
const GetPromoItemById = (body) => api3.endpoints.GetPromoItemById.post(body);
const AddOrUpdatePromoItem = (body) => api.endpoints.AddOrUpdatePromoItem.post(body);
const GetColors = () => api3.endpoints.GetColors.post();
const GetSizes = () => api3.endpoints.GetSizes.post();
const DeletePromoItem = (body) => api.endpoints.DeletePromoItem.post(body);
const UploadPromoItemFile = (data) => api.endpoints.UploadPromoItemFile.postData(data);
//promo item extra
const GetPromoItemLinksById = (body) => api.endpoints.GetPromoItemLinksById.post(body);
const AddOrUpdatePromoItemLink = (body) => api.endpoints.AddOrUpdatePromoItemLink.post(body);
const DeletePromoItemLink = (body) => api.endpoints.DeletePromoItemLink.post(body);

//onboarding
const GetOnBoardingList = () => api.endpoints.GetOnBoardingList.post();
const GetOnBoardingById = (body) => api.endpoints.GetOnBoardingById.post(body);
const GetOnBoardingCategories = () => api.endpoints.GetOnBoardingCategories.post();
const AddOrUpdateOnBoarding = (body) => api.endpoints.AddOrUpdateOnBoarding.post(body);
const DeleteOnBoarding = (body) => api.endpoints.DeleteOnBoarding.post(body);
const AddOnBoardingCategory = (body) => api.endpoints.AddOnBoardingCategory.post(body);
const UploadOnBoardingFile = (data) => api.endpoints.UploadOnBoardingFile.postData(data);

//software
const GetSoftwareList = () => api.endpoints.GetSoftwareList.post();
const GetSoftwareById = (body) => api.endpoints.GetSoftwareById.post(body);
const GetSoftwareCategories = () => api.endpoints.GetSoftwareCategories.post();
const AddOrUpdateSoftware = (body) => api.endpoints.AddOrUpdateSoftware.post(body);
const DeleteSoftware = (body) => api.endpoints.DeleteSoftware.post(body);
const UploadSoftwareFile = (data) => api.endpoints.UploadSoftwareFile.postData(data);
const UploadSoftwareImageFile = (data) => api.endpoints.UploadSoftwareImageFile.postData(data);

//compliance portal
const GetCompliancePortalList = () => api.endpoints.GetCompliancePortalList.post();
const GetCompliancePortalById = (body) => api.endpoints.GetCompliancePortalById.post(body);
const GetCompliancePortalCategories = () => api.endpoints.GetCompliancePortalCategories.post();
const AddOrUpdateCompliancePortal = (body) => api.endpoints.AddOrUpdateCompliancePortal.post(body);
const DeleteCompliancePortal = (body) => api.endpoints.DeleteCompliancePortal.post(body);
const UploadCompliancePortalFile = (data) =>
  api.endpoints.UploadCompliancePortalFile.postData(data);
const AddCompliancePortalCategory = (body) => api.endpoints.AddCompliancePortalCategory.post(body);
const DeleteCompliancePortalCategory = (body) =>
  api.endpoints.DeleteCompliancePortalCategory.post(body);

//news
const GetNewsList = () => api.endpoints.GetNewsList.post();
const GetNewsById = (body) => api.endpoints.GetNewsById.post(body);
const GetNewsCategories = () => api.endpoints.GetNewsCategories.post();
const GetProductCategories = () => api.endpoints.GetProductCategories.post();
const AddOrUpdateNews = (body) => api.endpoints.AddOrUpdateNews.post(body);
const DeleteNews = (body) => api.endpoints.DeleteNews.post(body);
const UploadNewsFile = (data) => api.endpoints.UploadNewsFile.postData(data);

//brokerage
const GetBrokerageList = () => api.endpoints.GetBrokerageList.post();
const GetBrokerageById = (body) => api.endpoints.GetBrokerageById.post(body);
const GetBrokerageCategories = () => api.endpoints.GetBrokerageCategories.post();
const GetBrokerageCompanies = () => api.endpoints.GetBrokerageCompanies.post();
const AddOrUpdateBrokerage = (body) => api.endpoints.AddOrUpdateBrokerage.post(body);
const DeleteBrokerage = (body) => api.endpoints.DeleteBrokerage.post(body);
const UploadBrokerageFile = (data) => api.endpoints.UploadBrokerageFile.postData(data);
//brokerage extra
const AddBrokerageCompany = (body) => api.endpoints.AddBrokerageCompany.post(body);
const AddBrokerageCategory = (body) => api.endpoints.AddBrokerageCategory.post(body);
const DeleteBrokerageCompany = (body) => api.endpoints.DeleteBrokerageCompany.post(body);
const DeleteBrokerageCategory = (body) => api.endpoints.DeleteBrokerageCategory.post(body);
const GetBrokerageLinksById = (body) => api.endpoints.GetBrokerageLinksById.post(body);
const AddOrUpdateBrokerageLink = (body) => api.endpoints.AddOrUpdateBrokerageLink.post(body);
const DeleteBrokerageItemLink = (body) => api.endpoints.DeleteBrokerageItemLink.post(body);

//learning center
const GetLearningCenterList = () => api.endpoints.GetLearningCenterList.post();
const GetLearningCenterById = (body) => api.endpoints.GetLearningCenterById.post(body);
const GetLearningCenterCategories = () => api.endpoints.GetLearningCenterCategories.post();
const AddOrUpdateLearningCenter = (body) => api.endpoints.AddOrUpdateLearningCenter.post(body);
const DeleteLearningCenterItem = (body) => api.endpoints.DeleteLearningCenterItem.post(body);
const AddLearningCenterCategory = (body) => api.endpoints.AddLearningCenterCategory.post(body);
const UploadLearningCenterFile = (data) => api.endpoints.UploadLearningCenterFile.postData(data);
const DeleteLearningCenterCategory = (body) =>
  api.endpoints.DeleteLearningCenterCategory.post(body);

//product toolkit
const GetProductToolkitList = () => api.endpoints.GetProductToolkitList.post();
const GetProductToolkitById = (body) => api.endpoints.GetProductToolkitById.post(body);
const GetProductToolkitCategoriesList = () => api.endpoints.GetProductToolkitCategoriesList.post();
const GetRecruitingAndSelectionList = () => api.endpoints.GetRecruitingAndSelectionList.post();
const AddOrUpdateProductToolkit = (body) => api.endpoints.AddOrUpdateProductToolkit.post(body);
const DeleteProductToolkitItem = (body) => api.endpoints.DeleteProductToolkitItem.post(body);
const GetRecruitingSupportList = () => api.endpoints.GetRecruitingSupportList.post();
const UploadProductToolkitFile = (data) => api.endpoints.UploadProductToolkitFile.postData(data);

//recruiting
const GetRecruitingList = () => api.endpoints.GetRecruitingList.post();
const GetRecruitingById = (body) => api.endpoints.GetRecruitingById.post(body);
const GetRecruitingCategories = () => api.endpoints.GetRecruitingCategories.post();
const AddOrUpdateRecruiting = (body) => api.endpoints.AddOrUpdateRecruiting.post(body);
const DeleteRecruiting = (body) => api.endpoints.DeleteRecruiting.post(body);
const AddRecruitingCategory = (body) => api.endpoints.AddRecruitingCategory.post(body);
const UploadRecruitingFile = (data) => api.endpoints.UploadRecruitingFile.postData(data);

//brokerage headers
const GetBrokerageHeaderList = () => api.endpoints.GetBrokerageHeaderList.post();
const GetBrokerageHeaderById = (body) => api.endpoints.GetBrokerageHeaderById.post(body);
const AddOrUpdateBrokerageHeader = (body) => api.endpoints.AddOrUpdateBrokerageHeader.post(body);
const DeleteBrokerageHeader = (body) => api.endpoints.DeleteBrokerageHeader.post(body);

//Marketing
const GetMarketItemByID = (body) => api.endpoints.GetMarketItemByID.post(body);
const SaveMarketingItem = (body) => api.endpoints.SaveMarketingItem.post(body);
const GetMarketingCmsList = () => api.endpoints.GetMarketingCmsList.post();
const DeleteMarketingItem = (body) => api.endpoints.DeleteMarketingItem.post(body);
const AddMarketingCampaign = (body) => api.endpoints.AddMarketingCampaign.post(body);
const DeleteMarketingCampaign = (body) => api.endpoints.DeleteMarketingCampaign.post(body);

//Selling Techniques
const AddOrUpdateSellingTechnique = (body) => api.endpoints.AddOrUpdateSellingTechnique.post(body);
const GetSellingTechniqueCategoryList = () => api.endpoints.GetSellingTechniqueCategoryList.post();
const GetSellingTechniqueByID = (id) => api.endpoints.GetSellingTechniqueByID.post(id);
const DeleteTechniqueByID = (id) => api.endpoints.DeleteTechniqueByID.post(id);
const UploadSellingTechniquesFile = (data) =>
  api.endpoints.UploadSellingTechniquesFile.postData(data);
const GetSellingTechniqueListCMS = () => api.endpoints.GetSellingTechniqueListCMS.post();

//ISD Marketing
const AddOrUpdateISDMarketing = (body) => api.endpoints.AddOrUpdateISDMarketing.post(body);
const DeleteISDMarketing = (id) => api.endpoints.DeleteISDMarketing.post(id);
const GetISDMarketingByID = (id) => api.endpoints.GetISDMarketingByID.post(id);
const AddISDMarketingCategory = (name) => api.endpoints.AddISDMarketingCategory.post(name);
const UploadISDMarketingFile = (data) => api.endpoints.UploadISDMarketingFile.postData(data);

//App Package Links
const AddOrUpdateAppPackageLinkID = (body) => api.endpoints.AddOrUpdateAppPackageLinkID.post(body);
const DeleteAppPackageLinkID = (body) => api.endpoints.DeleteAppPackageLinkID.post(body);
const GetAppPackageProductByProductID = (body) =>
  apiAppPack.endpoints.GetAppPackageProductByProductID.post(body);

// Forms
const AddOrUpdateForm = (body) => api.endpoints.AddOrUpdateForm.post(body);
const GetFormsList = (body) => api.endpoints.GetFormsList.post(body);
const GetFormsPaginatedList = (body) => api.endpoints.GetFormsPaginatedList.post(body);
const GetFormById = (body) => api.endpoints.GetFormById.post(body);
const GetFormCategories = () => api.endpoints.GetFormCategories.get();
const GetFormProducts = () => api.endpoints.GetFormProducts.get();
const GetStates = () => api.endpoints.GetStates.get();
const DeleteFormByID = ({ id, fileName }) =>
  api.endpoints.DeleteFormByID.deleteWithURI({ id, fileName });
const DeleteFormFile = ({ fileName }) => api.endpoints.DeleteFormFile.deleteWithURI({ fileName });
const UploadFormFile = (data) => api.endpoints.UploadFormFile.postData(data);

const GetLinkTypes = () => Promise.resolve([]);

export {
  GetDivisionList,
  GetProductsListForRef,
  //Emergency Notes
  GetEmergencyNoteList,
  GetEmergencyNotes,
  GetEmergencyNotesByDivision,
  DeleteEmergencyNote,
  AddOrUpdateEmergencyNote,
  //Products
  GetProductsList,
  GetProductById,
  GetProductLines,
  GetUnderWritingTypes,
  DeleteProduct,
  AddOrUpdateProduct,
  UploadProductFile,
  //Promos
  GetPromosList,
  GetPromoById,
  GetTemplateTypes,
  DeletePromo,
  AddOrUpdatePromo,
  UploadPromosFile,
  //PromoItem
  AddNewColor,
  GetPromoItemList,
  GetPromoItemById,
  AddOrUpdatePromoItem,
  GetColors,
  GetSizes,
  DeletePromoItem,
  UploadPromoItemFile,
  //PromoItem extra
  GetPromoItemLinksById,
  AddOrUpdatePromoItemLink,
  DeletePromoItemLink,
  //OnBoarding
  GetOnBoardingList,
  GetOnBoardingById,
  GetOnBoardingCategories,
  AddOrUpdateOnBoarding,
  DeleteOnBoarding,
  AddOnBoardingCategory,
  UploadOnBoardingFile,
  //Software
  GetSoftwareList,
  GetSoftwareById,
  GetSoftwareCategories,
  AddOrUpdateSoftware,
  DeleteSoftware,
  UploadSoftwareFile,
  UploadSoftwareImageFile,
  //Compliance Portal
  GetCompliancePortalList,
  GetCompliancePortalById,
  GetCompliancePortalCategories,
  AddOrUpdateCompliancePortal,
  DeleteCompliancePortal,
  UploadCompliancePortalFile,
  AddCompliancePortalCategory,
  DeleteCompliancePortalCategory,
  //News
  GetNewsList,
  GetNewsById,
  GetNewsCategories,
  GetProductCategories,
  AddOrUpdateNews,
  DeleteNews,
  UploadNewsFile,
  //Brokerage
  GetBrokerageList,
  GetBrokerageById,
  GetBrokerageCategories,
  GetBrokerageCompanies,
  AddOrUpdateBrokerage,
  DeleteBrokerage,
  UploadBrokerageFile,
  //Brokerage extra
  AddBrokerageCompany,
  AddBrokerageCategory,
  DeleteBrokerageCompany,
  DeleteBrokerageCategory,
  GetBrokerageLinksById,
  AddOrUpdateBrokerageLink,
  DeleteBrokerageItemLink,
  //Learning Center
  GetLearningCenterList,
  GetLearningCenterById,
  GetLearningCenterCategories,
  AddOrUpdateLearningCenter,
  DeleteLearningCenterItem,
  AddLearningCenterCategory,
  UploadLearningCenterFile,
  DeleteLearningCenterCategory,
  //Product Toolkit
  GetProductToolkitList,
  GetProductToolkitById,
  GetProductToolkitCategoriesList,
  GetRecruitingAndSelectionList,
  AddOrUpdateProductToolkit,
  DeleteProductToolkitItem,
  GetRecruitingSupportList,
  UploadProductToolkitFile,
  //Recruiting
  GetRecruitingList,
  GetRecruitingById,
  GetRecruitingCategories,
  AddOrUpdateRecruiting,
  DeleteRecruiting,
  AddRecruitingCategory,
  UploadRecruitingFile,
  //Brokerage Headers
  GetBrokerageHeaderList,
  GetBrokerageHeaderById,
  AddOrUpdateBrokerageHeader,
  DeleteBrokerageHeader,
  //Marketing
  GetMarketItemByID,
  SaveMarketingItem,
  GetMarketingCmsList,
  DeleteMarketingItem,
  AddMarketingCampaign,
  DeleteMarketingCampaign,
  //Selling Techniques
  AddOrUpdateSellingTechnique,
  GetSellingTechniqueCategoryList,
  GetSellingTechniqueByID,
  DeleteTechniqueByID,
  UploadSellingTechniquesFile,
  GetSellingTechniqueListCMS,
  //ISD Marketing
  AddOrUpdateISDMarketing,
  DeleteISDMarketing,
  GetISDMarketingByID,
  AddISDMarketingCategory,
  UploadISDMarketingFile,
  //App Package Links
  AddOrUpdateAppPackageLinkID,
  DeleteAppPackageLinkID,
  GetAppPackageProductByProductID,
  // Forms
  AddOrUpdateForm,
  GetFormsList,
  GetFormsPaginatedList,
  GetFormById,
  GetFormCategories,
  GetFormProducts,
  GetStates,
  DeleteFormByID,
  DeleteFormFile,
  UploadFormFile,
  GetLinkTypes,
};
